export default "__VITE_ASSET__UtHCfbSK__"